import React, { useState } from "react";
import useReportListLogic, { Report } from "./Reports.logic";
import { DataTable, DataTableFilterMeta } from "primereact/datatable";
import { Column } from "primereact/column";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { ConfirmPopup } from "primereact/confirmpopup";
import { formatDate } from "../../utils/dateUtils";

const ReportList: React.FC = () => {
  const { transactions, loading } = useReportListLogic();

  const statusBodyTemplate = (rowData: Report) => {
    return rowData.status == "resolved" ? (
      <span className="p-tag p-tag-success">{rowData.status_label}</span>
    ) : rowData.status == "rejected" ? (
      <span className="p-tag p-tag-danger">{rowData.status_label}</span>
    ) : (
      <span className="p-tag p-tag-info">{rowData.status_label}</span>
    );
  };

  const [globalFilterValue, setGlobalFilterValue] = useState<string>("");

  const [filters, setFilters] = useState<DataTableFilterMeta>({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    let _filters = { ...filters };

    // @ts-ignore
    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const renderHeader = () => {
    return (
      <>
        <ConfirmPopup />
        <div className="flex justify-content-start align-items-center mb-2 flex-column-responsive">
          <IconField iconPosition="left">
            <InputIcon className="fas fa-search" />
            <InputText
              value={globalFilterValue}
              onChange={onGlobalFilterChange}
              placeholder="Keyword Search"
            />
          </IconField>
        </div>
      </>
    );
  };

  const header = renderHeader();

  const eventBodyTemplate = (rowData: Report) => {
    return (
      <div>
        <div>
          <strong>{rowData.Event.title}</strong>
        </div>
        <small className="text-muted">
          {formatDate(rowData.Event.datetime)} | {rowData.Event.location_city}
        </small>
      </div>
    );
  };

  return (
    <>
      <section className="schedule-three ngo_list_wrapper">
        <div className="container">
          <div className="schedule-three__top">
            <div
              className="section-title text-center wow fadeInLeft"
              data-wow-delay="100ms"
            >
              <h2 className="section-title__title">Your Reported Issues</h2>
            </div>
          </div>
          <div className="schedule-three__bottom">
            <DataTable
              value={transactions}
              removableSort
              sortField="createdAt"
              sortOrder={-1}
              showGridlines
              paginator
              rows={5}
              loading={loading}
              rowsPerPageOptions={[5, 10, 25, 50]}
              filters={filters}
              // filterDisplay="row"
              globalFilterFields={[
                "Event.title",
                "reportedHost.name",
                "reported_type_label",
                "reason",
                "comment",
                "status_label",
              ]}
              header={header}
              emptyMessage="No reported issues found."
              onFilter={(e) => setFilters(e.filters)}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Reported Issues"
              tableStyle={{ minWidth: "50rem" }}
            >
              <Column
                field="Event.title"
                header="Event"
                body={eventBodyTemplate}
                sortable
              ></Column>
              <Column
                field="reportedHost.name"
                header="Event Host"
                sortable
              ></Column>
              <Column
                field="reported_type_label"
                header="Reported For"
                sortable
              ></Column>
              <Column
                field="reason"
                header="Reason for Report"
                sortable
              ></Column>
              <Column field="comment" header="Comment" sortable></Column>
              <Column
                headerStyle={{ width: "10%", minWidth: "8rem" }}
                field="status_label"
                header="Status"
                bodyStyle={{ textAlign: "center" }}
                body={statusBodyTemplate}
                headerClassName="custom-status-column"
              ></Column>
              <Column
                field="createdAt"
                header="Reported At"
                body={(rowData: Report) => rowData.reported_at_formatted}
                sortable
              ></Column>
            </DataTable>
          </div>
        </div>
      </section>
    </>
  );
};

export default ReportList;
